import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const ContactUs = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Contact Us</h1>
        <p className="policy-subtitle">We're here to help.</p>

        <section className="policy-section">
          <p>Whether you have a question about your order, want to learn more about QuitStick, or simply need support on your quitting journey — we'd love to hear from you.</p>
        </section>

        <section className="policy-section contact-details">
          <h2>Get in Touch</h2>
          <div className="contact-item">
            <strong>Phone:</strong> <a href="tel:+919667671383">+91 9667671383</a>
          </div>
          <div className="contact-item">
            <strong>Email:</strong> <a href="mailto:support@quitstick.in">support@quitstick.in</a>
          </div>
          <div className="contact-item">
            <strong>Address:</strong> New Delhi, 110001
          </div>
          <div className="contact-item">
            <strong>Response Time:</strong> We typically respond within 24–48 business hours.
          </div>
        </section>

        <section className="policy-section">
          <h2>Business Hours</h2>
          <p>Monday to Saturday — 10:00 AM to 6:00 PM IST<br/>
          Closed on Sundays and national public holidays.</p>
        </section>

        <section className="policy-section">
          <h2>Before You Reach Out</h2>
          <p>You may find an instant answer to your question in our FAQ section on the homepage. We've covered the most common questions about QuitStick, how it works, and how to use it effectively.</p>
        </section>

        <section className="policy-section">
          <h2>Feedback & Partnerships</h2>
          <p>We're always open to feedback, brand collaborations, or wholesale inquiries. If you're a healthcare professional, therapist, or wellness brand interested in partnering with QuitStick, please reach out to us at <a href="mailto:hello@quitstick.in">hello@quitstick.in</a> and we'll get back to you as soon as possible.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default ContactUs;
